












































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import FlightReservationOrder from "@/store/entities/flight/reservation/flightReservationOrder";
import ReservationList from "@/store/entities/flight/reservation/reservationList";
import PassengerInherit from "@/store/entities/passangerInherit";
import CancelOrder from "@/store/entities/flight/reservation/cancelOrder";
import ApproveOrderById from "@/store/entities/flight/reservation/approveOrderById";
import Customer from "@/store/entities/customer";
import ajax from "@/lib/ajax";
import Refund from "@/store/entities/refund";
import Currency from "@/store/entities/currency";
@Component({
  components: {
  },
})
export default class ReservationDetailModal extends Vue {
  radios: boolean = true;
  dialog: boolean = true;
  dialogAgree: boolean = false;
  dialogRefund: boolean = false;
  dialogAmount: boolean = false;
  dialogChangeCurrency: boolean = false;
  dialogConfirm: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  mockDataOperatorHistory: any[] = [];
  headersOperatorHistory: any[] = [];
  mockDataFlightOrder: any[] = [];
  headersFlightOrder: any[] = [];
  active_tab: number = 0;
  isOpenRow: boolean = false;
  isOpenFlightOrder: boolean = true;
  mockDataPassangers: any[] = [];
  headersPassangers: any[] = [];
  isOpenModal: boolean = false;
  reservationList: FlightReservationOrder[] = [];
  flightOrders: FlightReservationOrder[] = [];
  passengers: PassengerInherit[] = [];
  flightNo: string;
  radioGroup: number | string = 1;
  cancelOrder: CancelOrder = new CancelOrder();
  orderId: string = "";
  currencyId:string;
  pdfLink:string="";
  refundTotal:number=0;
  extraTotal:number=0;
  currencies: Currency[] = [];
  currency:Currency=new Currency();
  amount:number=0;

  
  get totalPrice(){
    if(this.reservationList.length>1){
      return this.reservationList[0].totalPrice +  this.reservationList[1].totalPrice 
    }
    return this.reservationList[0].totalPrice
    
  }

  async getCurrencies() {
    await this.$store.dispatch({
      type: "currency/getCurrencies",
    });

    this.currencies = this.$store.state.currency.list;
  }
 
  async created() {

    this.reservationList = this.$store.state.reservation.reservationDetail;

    this.orderId=this.reservationList[0].orderId;
    this.currencyId=this.reservationList[0].currencyId;

    this.getCurrencies();

    if(this.reservationList[0].order.orderStatus == 4){
        this.pdfUrl();
    }


    
    (this.headers = [
      { text: "", value: "" },
      { text: this.$t('reservationDetail.headers.paymentType'), value: "paymentType" },
      { text: this.$t('reservationDetail.headers.paymentStatus'), value: "paymentStatus" },
      { text: this.$t('common.price'), value: "price" },
      { text: this.$t('common.currency'), value: "currency" },
      { text: this.$t('reservationDetail.headers.creationDate'), value: "creationDate" },
    ]),

      (this.headersOperatorHistory = [
        { text: "operator", value: "operator" },
        { text: "isAssigned", value: "isAssigned" },
        { text: this.$t('reservationDetail.headers.operatorStatus'), value: "operatorStatus" },
        { text: this.$t('reservationDetail.headers.note'), value: "isNote" },
        { text: this.$t('reservationDetail.headers.creationDate'), value: "creationDate" },
      ]),
      (this.headersFlightOrder = [
        { text: "", align: "start", filterable: false, value: "" },
        { text: "", align: "start", filterable: false, value: "" },
        { text: this.$t('reservationDetail.headers.pnr'), value: "pnr" },
        { text: this.$t('reservationDetail.headers.airlineName'), value: "companies" },
        { text: this.$t('reservationDetail.headers.route'), value: "destination" },
        { text: this.$t('reservationDetail.headers.orderStatus'), value: "orderStatus" },
        { text: this.$t('reservationDetail.headers.passengerCount'), value: "passangerCount" },
        { text: this.$t('reservationDetail.headers.creationDate'), value: "creationDate" },
      ]),
      (this.headersPassangers = [
        { text: this.$t('common.flight'), value: "flight" },
        { text: this.$t('reservationDetail.headers.flightClass'), value: "flightClass" },
        { text: this.$t('reservationDetail.headers.name'), value: "name" },
        { text: this.$t('reservationDetail.headers.passengerType'), value: "passangerType" },
        { text: this.$t('reservationDetail.headers.gender'), value: "gender" },
        { text: this.$t('reservationDetail.headers.birthday'), value: "birthday" },
        { text: this.$t('reservationDetail.headers.passport'), value: "passport" },
        { text: this.$t('reservationDetail.headers.passportExpiryDate'), value: "validityDate" },
        { text: this.$t('common.price'), value: "price" },
      ]);
  }

  async confirmReservation () {

    this.orderId=this.reservationList[0].orderId;
    await this.$store
      .dispatch({
        type: "reservation/approveOrderById",
        data: this.orderId,

      })
      .then((res) => {
        if (res.status === 200) {
          this.dialogConfirm = false;
          this.dialog = false;
        }
      });


  }
  async updateBookingPayment(){
    let item ={"orderId":this.orderId,"totalPrice":this.amount,"currencyId":this.currency.id}
   
    await this.$store
      .dispatch({
        type: "reservation/updateBookingPayment",
        data: item,
      }).then((res) => {
        if (res.status === 200) {
            Vue.$toast.success(this.$t('reservationDetail.messages.currencyChanged') as string);
            this.dialogChangeCurrency=false;
        }
        
      });
  }
  async saveRefund(paymentRule:number){
    var message="";
    let item = new Refund();
    item.orderId=this.reservationList[0].orderId;
    item.paymentRule=paymentRule;
    if(paymentRule==0){
      item.total=this.refundTotal;
      message=this.$t('reservationDetail.messages.partialRefundSuccess') as string;
    }
    else{
      item.total=this.extraTotal;
      message=this.$t('reservationDetail.messages.amountAddedSuccess') as string;
    }
    
    

    await this.$store
      .dispatch({
        type: "reservation/saveRefund",
        data: item,
      }).then((res) => {
        if (res.status === 200) {
            Vue.$toast.success(message);

        }
        
      });


      this.dialogRefund=false;
  }
  async cancelReservation() {
    const array = [
      {
        orderId: this.reservationList[0].orderId,
        isOutOfProviderQuota: false,
        isOutOfQuota: false,
        flightOrderRefundRequests: [
          {
            orderId: this.reservationList[0].orderId,
            refundTo: 1,
            total: this.reservationList[0].totalPrice,
            currencyId: this.reservationList[0].currencyId,
          },
        ],
      },
    ];
    this.cancelOrder.orders = array;

    await this.$store
      .dispatch({
        type: "reservation/cancelOrder",
        data: this.cancelOrder,
      })
      .then((res) => {
        if (res.status === 200) {
          this.dialogAgree = false;
          this.dialog = false;
        }
      });
  }

  data() {
    return {
      items: [
        { title: this.$t('reservationDetail.menu.orderPayment') },
        { title: this.$t('common.cancel') },
        { title: this.$t('reservationDetail.menu.grayPayments') },
      ],
    };
  }

    async  pdfUrl(){
  
     var response= await this.$store
      .dispatch({
        type: "reservation/pdfLink",
        data: this.reservationList[0].orderId,
      })
      this.pdfLink = response;
     
  }

  get getPassengers() {
    return this.radioGroup === 1
      ? this.reservationList[0].passengers
      : this.reservationList[1].passengers;
  }

  get pnrAndFlightNo() {
    return this.radioGroup === 1
      ? `${this.reservationList[0].pnr} - ${this.reservationList[0].flightNo}`
      : `${this.reservationList[0].pnr} - ${this.reservationList[0].flightNo}`;
  }

  closeDialog() {
    this.$emit("closed");
  }

  openRow() {
    this.isOpenRow = true;
  }
  closeRow() {
    this.isOpenRow = false;
  }

  openFlightOrder() {
    this.isOpenFlightOrder = true;
  }
  closeFlightOrder() {
    this.isOpenFlightOrder = false;
  }

  openModal() {
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
  }

}
